import {
  getMainArtBCs,
  getMainWpBCs,
  getSubArtBCs,
  getSubArtDCs,
  getSubWpBCs,
  getVisionCount,
  getWpRange
} from "../app/calculatorSlice/helpers";
import { initCharMCs } from "../app/calculatorSlice/initiators";
import { rsnNames } from "../configs";
import { findCharacter } from "../data/controllers";

export function processNumInp(inp, before, max) {
  if (inp === "") return 0;
  if (!isNaN(inp) && inp >= 0 && inp <= max) {
    if (inp.slice(-1) === ".") return inp;
    return Math.round(inp * 10) / 10;
  }
  return before;
}

export function filterAllMCs(data) {
  const { char, subWpMCs, art, selfMCs, weapon, elmtMCs } = data;
  function filter(list) {
    return list.filter((elmt) => elmt.activated);
  }
  function filterSelfMCs(list, type) {
    const modList = findCharacter(char)[type];
    return filter(list).filter((ctrl) => {
      if (!modList) return false;
      const mod = modList.find(({ index }) => index === ctrl.index);
      return mod && mod.isGranted(char);
    });
  }
  const subWpBCs = {};
  for (const type in subWpMCs.BCs) {
    subWpBCs[type] = filter(subWpMCs.BCs[type]);
  }
  const artMCs = {};
  for (const type of ["BCs", "subBCs", "subDCs"]) {
    artMCs[type] = filter(art[type]);
  }
  return {
    selfMCs: {
      BCs: filterSelfMCs(selfMCs.BCs, "buffs"),
      DCs: filterSelfMCs(selfMCs.DCs, "debuffs")
    },
    weapon: { ...weapon, BCs: filter(weapon.BCs) },
    subWpMCs: { BCs: subWpBCs, DCs: [] },
    art: { ...art, ...artMCs },
    party: data.party.map((tm) => {
      if (!tm) return null;
      return { name: tm.name, BCs: filter(tm.BCs), DCs: filter(tm.DCs) };
    }),
    elmtMCs: { ...elmtMCs, resonance: filter(elmtMCs.resonance) }
  };
}

// [MySetups/helpers, MySetups/Setup/index]
export function restoreAllMCs(data) {
  function restoreMCs(oldMCs, newMCs) {
    for (const ctrl of oldMCs) {
      const i = newMCs.findIndex((c) => c.index === ctrl.index);
      if (i >= 0) {
        newMCs[i].activated = true;
        if (ctrl.inputs && newMCs[i].inputs) {
          newMCs[i].inputs = ctrl.inputs;
        }
      }
    }
  }
  const { char, weapon, elmtMCs } = data;
  console.log(data);

  const selfMCs = initCharMCs(char.name, true);
  for (const type of ["BCs", "DCs"]) {
    restoreMCs(data.selfMCs[type], selfMCs[type]);
  }
  const mainWpBCs = getMainWpBCs(weapon);
  restoreMCs(weapon.BCs, mainWpBCs);

  const subWpBCs = {};
  for (const type in getWpRange(data.party)) {
    subWpBCs[type] = getSubWpBCs(type, weapon.code);
    if (!data.subWpMCs.BCs[type]) continue;
    for (const ctrl of data.subWpMCs.BCs[type]) {
      const i = subWpBCs[type].findIndex(
        (c) => c.code === ctrl.code && c.index === ctrl.index
      );
      if (i >= 0) {
        subWpBCs[type][i].activated = true;
        subWpBCs[type][i].refinement = ctrl.refinement;
      }
    }
  }
  const firstSet = data.art.sets[0];
  const setCode = firstSet && firstSet.bonusLv ? firstSet.code : null;
  const artMCs = {
    BCs: getMainArtBCs(setCode),
    subBCs: getSubArtBCs(setCode),
    subDCs: getSubArtDCs()
  };
  for (const type of ["BCs", "subBCs", "subDCs"]) {
    for (const ctrl of data.art[type]) {
      const i = artMCs[type].findIndex(
        (c) => c.code === ctrl.code && c.index === ctrl.index
      );
      if (i >= 0) {
        artMCs[type][i].activated = true;
        if (ctrl.inputs && artMCs[type][i].inputs) {
          artMCs[type][i].inputs = ctrl.inputs;
        }
      }
    }
  }
  const party = [null, null, null];
  for (const tmI in data.party) {
    if (data.party[tmI]) {
      const { name } = data.party[tmI];
      party[tmI] = { name, ...initCharMCs(name, false) };
      for (const type of ["BCs", "DCs"]) {
        restoreMCs(data.party[tmI][type], party[tmI][type]);
      }
    }
  }
  const resonance = [];
  const vsc = getVisionCount(char, party);
  for (const elmt in vsc) {
    const name = rsnNames[elmt];
    if (vsc[elmt] >= 2 && name) {
      const { activated = false, inputs = [] } =
        elmtMCs.resonance.find((rsn) => rsn.name === name) || {};
      const resonancePair = { name, activated };

      if (elmt === "Dendro") {
        resonancePair.inputs = inputs;
      }
      resonance.push(resonancePair);
    }
  }
  return {
    selfMCs,
    weapon: { ...data.weapon, BCs: mainWpBCs },
    subWpMCs: {
      BCs: subWpBCs,
      DCs: {}
    },
    art: { ...data.art, ...artMCs },
    party,
    elmtMCs: { ...elmtMCs, resonance }
  };
}
